/**
 * Map fenced-code language tags (from ```lang) to Prism grammar names.
 * Covers common aliases: c++, py, sh, yml, etc.
 */
const ALIASES = {
  bash: "bash",
  sh: "bash",
  shell: "bash",
  zsh: "bash",
  console: "bash",
  terminal: "bash",
  pwsh: "powershell",
  ps1: "powershell",
  powershell: "powershell",

  c: "c",
  cpp: "cpp",
  "c++": "cpp",
  cxx: "cpp",
  cc: "cpp",
  hpp: "cpp",
  h: "c",
  csharp: "csharp",
  cs: "csharp",
  dotnet: "csharp",

  py: "python",
  python: "python",
  python3: "python",

  js: "javascript",
  javascript: "javascript",
  mjs: "javascript",
  cjs: "javascript",
  ts: "typescript",
  typescript: "typescript",
  tsx: "tsx",
  jsx: "jsx",
  json: "json",
  jsonc: "json",
  html: "markup",
  xml: "markup",
  svg: "markup",
  css: "css",
  scss: "scss",
  sass: "sass",
  less: "less",
  md: "markdown",
  markdown: "markdown",
  yaml: "yaml",
  yml: "yaml",

  rust: "rust",
  rs: "rust",
  go: "go",
  golang: "go",
  java: "java",
  kt: "kotlin",
  kotlin: "kotlin",
  swift: "swift",
  rb: "ruby",
  ruby: "ruby",
  php: "php",
  sql: "sql",
  graphql: "graphql",
  gql: "graphql",
  docker: "docker",
  dockerfile: "docker",
  diff: "diff",
  patch: "diff",
  git: "git",
  toml: "toml",
  ini: "ini",
  properties: "properties",
  env: "bash",

  nginx: "nginx",
  apache: "apacheconf",
};

const SAFE_FALLBACK = "plaintext";

export function normalizePrismLanguage(tag) {
  const key = tag.trim().toLowerCase();
  if (!key) return SAFE_FALLBACK;
  const mapped = ALIASES[key] ?? key;
  return mapped;
}
